import React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import LayersSharpIcon from '@mui/icons-material/LayersSharp';
import PolylineSharpIcon from '@mui/icons-material/PolylineSharp';
import FilterAltSharpIcon from '@mui/icons-material/FilterAltSharp';
import VectorLayerSwitch from './VectorLayerSwitch';
import RasterlayerRadiobutton from './RasterlayerRadiobutton'
import MapStyleRadiobutton from './MapStyleRadiobutton'
import Filtergroup from './Filtergroup'
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import MapSharpIcon from '@mui/icons-material/MapSharp';
import { bgColors } from '../../utils/bgColor';
const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default function MapCustomization() {
  const [expanded, setExpanded] = React.useState(null);
  const handleChange =
    (panel) => (event, newExpanded) => {
      setExpanded(newExpanded ? panel : false);
    };

    // <Typography 
    //           sx ={{
    //               fontSize: 14, 
    //                fontWeight:'bold',
    //                fontFamily:'serif',
    //                padding:'0.25rem',
    //                color:bgColors.font_blue
    //                }}
    //             >{"Map style"}
    //           </Typography> 

  return (
    <div>
      <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography 
          sx ={{
            fontSize: 16, 
             fontWeight:'bold',
             fontFamily:'serif',
             padding:'0.25rem',
             color:bgColors.grey_700
             }}
          
          > <MapSharpIcon/> Map style </Typography>
          </AccordionSummary>
            <MapStyleRadiobutton/>
      </Accordion>
      <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
          <Typography 
          sx ={{
            fontSize: 16, 
             fontWeight:'bold',
             fontFamily:'serif',
             padding:'0.25rem',
             color:bgColors.grey_700
             }}
          
          > <PolylineSharpIcon/> Boundries & labels </Typography>
        </AccordionSummary>
        {/* <Card sx = {{maxHeight:'300px', overflow:'auto'}}> */}
            {/* <MapStyleRadiobutton/>
            <Divider sx = {{background:bgColors.grey_300 , borderBottomWidth: '2px'}}/> */}

            <VectorLayerSwitch/>
        {/* </Card> */}
      </Accordion>
      <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
          <Typography   sx ={{
                  fontSize: 16, 
                   fontWeight:'bold',
                   fontFamily:'serif',
                   padding:'0.25rem',
                   color:bgColors.grey_700
                   }}> <LayersSharpIcon/> Index layer </Typography>
        </AccordionSummary>
        <AccordionDetails >
        {/* <Card sx = {{maxHeight:'300px', overflow:'auto'}}> */}
        <RasterlayerRadiobutton/>
        {/* </Card> */}
        </AccordionDetails>
        
      </Accordion>
      <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
          <Typography sx ={{
                  fontSize: 16, 
                   fontWeight:'bold',
                   fontFamily:'serif',
                   padding:'0.25rem',
                   color:bgColors.grey_700
                   }}><FilterAltSharpIcon/> Apply filters</Typography>
        </AccordionSummary>
        <AccordionDetails>
        {/* <Card sx = {{maxHeight:'300px', overflow:'auto'}}> */}
            <Filtergroup/>
            {/* </Card> */}
        </AccordionDetails>

      </Accordion>
    </div>
  );
}